import React from "react";
import { Button, Modal } from "react-bootstrap";


const InsiteModal = (props) => {
    const { showRemarksModal, setShowRemarksModal, item } = props

    const handleClose = () => {
        setShowRemarksModal(false)
        console.log("Handle Close Remark Modal");
    }
    const handleSubmitRemark = () => {
        setShowRemarksModal(false)
        console.log("Handle Submit Remark Modal");
    }

    return (<>
        <Modal
            size="md"
            backdrop="static"
            keyboard={false}
            show={showRemarksModal}
            onHide={handleClose}
        >
            <Modal.Body className="modal-body">
                <div className="row">
                    <img src={item?.image} alt="Insights" className="img-fluid mb-4" />
                    <h5>{item?.name}</h5>

                    <p className="text-muted">
                        If you haven't unlocked a report for this influencer before,
                        by clicking <strong>"continue"</strong> you'd be charged
                        <strong>1 token</strong> for it.
                    </p>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="hstack gap-2 justify-content-end">
                    <Button
                        variant="danger"
                        className="btn btn-light"
                        onClick={handleClose}
                    >
                        Close
                    </Button>
                    <Button
                        variant="success"
                        className="btn btn-success"
                        onClick={handleSubmitRemark}
                    >
                        Continue
                    </Button>{" "}
                </div>
            </Modal.Footer>
        </Modal>
    </>);
};

export default InsiteModal;
